var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91654 11.0833H3.74779L9.44988 5.38125L8.61863 4.55L2.91654 10.2521V11.0833ZM1.74988 12.25V9.77083L9.44988 2.08542C9.56654 1.97847 9.69536 1.89583 9.83634 1.8375C9.97731 1.77917 10.1256 1.75 10.2811 1.75C10.4367 1.75 10.5874 1.77917 10.7332 1.8375C10.879 1.89583 11.0054 1.98333 11.1124 2.1L11.9145 2.91667C12.0311 3.02361 12.1162 3.15 12.1697 3.29583C12.2231 3.44167 12.2499 3.5875 12.2499 3.73333C12.2499 3.88889 12.2231 4.03715 12.1697 4.17812C12.1162 4.3191 12.0311 4.44792 11.9145 4.56458L4.22904 12.25H1.74988ZM9.02696 4.97292L8.61863 4.55L9.44988 5.38125L9.02696 4.97292Z",
    fill: "#4A552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.522bef7b0dc7205a40986df0f3d8facd.svg";
export { ForwardRef as ReactComponent };